module.exports = "https://deal-img.imgix.net/consumer/not-found.cb6cc1da.png";